import { render, staticRenderFns } from "./BizCompanyEdit.vue?vue&type=template&id=22434449"
import script from "./BizCompanyEdit.vue?vue&type=script&lang=js"
export * from "./BizCompanyEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports